import { type Component, type ComponentInProject } from '@gql/graphql';
import { type ComponentDetailsViewModel } from '../models/ComponentDetailsViewModel';

export function fromComponent(component: Component): ComponentDetailsViewModel {
    return {
        id: component.id,
        name: component.name,
        version: component.version,
        vendorName: component.componentVendor.name,
        eolDate: component.eolDate,
        eolReached: component.eolReached,
        isValid: component.isValid,
        monitoredSince: component.monitoredSince,
        url: component.url,
        securityUrl: component.securityUrl,
        cpeName: component.cpeName,
    };
}

export function fromComponentInProject(
    component: ComponentInProject,
): ComponentDetailsViewModel {
    return {
        id: component.id,
        name: component.name,
        version: component.version,
        vendorName: component.componentVendorName,
        eolDate: component.eolDate,
        eolReached: component.eolReached,
        isValid: component.isValid,
        monitoredSince: component.monitoredSince,
        url: component.url,
        securityUrl: component.securityURL,
        cpeName: component.cpeName,
    };
}
